export default "__VITE_ASSET__BgQente3__"